/* eslint-disable no-plusplus */

import { isBefore, parseISO } from "date-fns";

// eslint-disable-next-line import/prefer-default-export
export const sortQueque = (firstItem: string, secondItem: string) => {
  const firstDate = parseISO(firstItem);
  const secondDate = parseISO(secondItem);
  return isBefore(firstDate, secondDate) ? 1 : -1;
};
